"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticLogChannel = void 0;
const OnlineResourceManager_1 = require("../OnlineResourceManager/OnlineResourceManager");
const logStoreName = "logs";
const localStorageLogIndexKey = "log-database-last-read-key";
class ElasticLogChannel {
    constructor(token, account_id, render_version) {
        this.initiateLogChannel = () => {
            const request = indexedDB.open("log-database", 1);
            request.onblocked = function () {
                alert("Couldn't upgrade log database, please close any other instances of this page, and reload this page.");
            };
            request.onupgradeneeded = function () {
                const db = request.result;
                if (!db.objectStoreNames.contains(logStoreName)) {
                    db.createObjectStore(logStoreName, { keyPath: "id", autoIncrement: true });
                }
            };
            request.onerror = function () {
                console.error("Couldn't load database for logging events");
            };
            request.onsuccess = () => {
                this.db = request.result;
                this.db.onerror = (event) => {
                    var _a, _b;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    console.error(`Database error: ${(_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message}`);
                };
                // call it once before starting the interval, to read through the store and send any logs that might be present
                this.sendLog();
                // call send log method every 10 minutes
                this.sendLogInterval = setInterval(this.sendLog, 10 * 60 * 1000);
            };
        };
        this.restrictLoggingToCurrentPage = () => {
            if (!("BroadcastChannel" in self)) {
                // BroadcastChannel API is not supported!
                // The browser which is executing this code is older than chrome 54.
                return;
            }
            const broadcastChannel = new BroadcastChannel("elastic-log-channel-broadcast-channel");
            broadcastChannel.onmessage = (message) => {
                if (message.data.cmd === "stop-sendLog" && this.sendLogInterval) {
                    console.log("Stopped send log interval");
                    clearInterval(this.sendLogInterval);
                    this.sendLogInterval = undefined;
                }
            };
            broadcastChannel.postMessage({ cmd: "stop-sendLog" });
        };
        this.sendLog = () => {
            let previousLogKey = localStorage.getItem(localStorageLogIndexKey);
            // If no logs have been sent previously, the log index key will not be defined and will return null.
            if (previousLogKey == null)
                previousLogKey = "0";
            if (this.db) {
                const transaction = this.db.transaction(logStoreName);
                transaction.onerror = function () {
                    console.error("An error occurred while reading from the database");
                };
                const store = transaction.objectStore(logStoreName);
                const request = store.getAll(IDBKeyRange.lowerBound(Number(previousLogKey), true));
                request.onsuccess = () => {
                    const logBuffer = [];
                    const logs = request.result;
                    if (logs.length === 0)
                        return;
                    const lastLogKey = logs[logs.length - 1].id;
                    localStorage.setItem(localStorageLogIndexKey, lastLogKey);
                    logs.forEach(log => {
                        delete log.id;
                        logBuffer.push(log);
                    });
                    // The token can be either a user id or a player token.
                    const onlineResource = this.onlineResourceManager.makeJSONRequest("/api/elastic/log/" + this.token, "POST", JSON.stringify({ "logs": logBuffer }));
                    onlineResource.getResponseRaw()
                        .then(() => {
                        this.clearLogs();
                    })
                        .catch(error => {
                        console.error("An error occurred while sending logs", error);
                        localStorage.setItem(localStorageLogIndexKey, String(previousLogKey));
                    });
                };
            }
        };
        this.log = (logEntry) => {
            var _a;
            if (logEntry.severity === "TRACE") {
                // we don't support trace log lavel on the logging service
                return;
            }
            const logItem = {
                index: "render",
                log_level: logEntry.severity.toLowerCase(),
                account_id: this.account_id,
                render_version: this.render_version,
                message: {
                    timestamp: logEntry.timestamp,
                    render: {
                        message: logEntry.message,
                        stack_trace: (_a = logEntry.stack_trace) !== null && _a !== void 0 ? _a : "",
                    }
                },
            };
            this.bufferLog(logItem);
        };
        this.token = token;
        this.account_id = account_id;
        this.onlineResourceManager = new OnlineResourceManager_1.OnlineResourceManager();
        this.render_version = render_version;
    }
    bufferLog(log) {
        if (this.db) {
            const transaction = this.db.transaction(logStoreName, "readwrite");
            transaction.onerror = () => {
                console.error("failed to save log in log buffer");
            };
            const logStore = transaction.objectStore(logStoreName);
            logStore.add(log);
        }
    }
    clearLogs() {
        const lastLogKey = localStorage.getItem(localStorageLogIndexKey);
        if (this.db) {
            const transaction = this.db.transaction(logStoreName, "readwrite");
            transaction.onerror = function () {
                console.error("An error occurred while clearing the database");
            };
            const store = transaction.objectStore(logStoreName);
            store.delete(IDBKeyRange.upperBound(Number(lastLogKey)));
        }
    }
}
exports.ElasticLogChannel = ElasticLogChannel;
